
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"16","height":"21"}},[_c('path',{attrs:{"d":"M15.75 0H0v21h15.75V0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)","fill":"#fff"}},[_c('path',{attrs:{"d":"M15.573 5.102L10.726.18a.602.602 0 00-.428-.18h-8.48C.814 0 0 .828 0 1.846v17.308C0 20.172.815 21 1.817 21h12.116c1.002 0 1.817-.828 1.817-1.846V5.537a.626.626 0 00-.177-.435zm-4.67-3.001l2.779 2.82H11.51a.611.611 0 01-.606-.614V2.1zm3.03 17.669H1.817a.611.611 0 01-.605-.616V1.846c0-.34.271-.616.605-.616h7.875v3.077c0 1.017.816 1.845 1.818 1.845h3.029v13.002c0 .34-.272.616-.606.616z"}}),_c('path',{attrs:{"d":"M11.51 8.695H4.24a.61.61 0 00-.605.616c0 .34.27.615.605.615h7.27a.61.61 0 00.605-.615.61.61 0 00-.605-.616zM11.51 11.156H4.24a.61.61 0 00-.605.615c0 .34.27.616.605.616h7.27a.61.61 0 00.605-.616.61.61 0 00-.605-.615zM11.51 13.617H4.24a.61.61 0 00-.605.615c0 .34.27.616.605.616h7.27a.61.61 0 00.605-.616.61.61 0 00-.605-.615zM9.087 16.078H4.24a.61.61 0 00-.605.615c0 .34.27.616.605.616h4.847a.61.61 0 00.605-.616.61.61 0 00-.605-.615z"}})])])
          )
        }
      }
    